import { ISemanticEvent } from './semanticEvent.interfcace';

export const isSemanticEvent = (e: unknown): e is ISemanticEvent => {
  return typeof e === 'object' && e !== null && typeof e['name'] === 'string' && typeof e['timestamp'] !== 'undefined';
};
